import { useState, useEffect } from 'react';
import { fetchJson } from './utils/apiFetch';

let cachedAuthStatus = null;
let authStatusRequest = null;

const getAuthStatus = async () => {
    if (cachedAuthStatus) {
        return cachedAuthStatus;
    }

    if (!authStatusRequest) {
        authStatusRequest = fetchJson('/api/auth/status')
            .then(results => {
                cachedAuthStatus = results;
                return results;
            });
        authStatusRequest.then(
            () => { authStatusRequest = null; },
            () => { authStatusRequest = null; }
        );
    }

    return authStatusRequest;
};

const useAuthStatus = () => {
    const [authenticated, setAuthenticated] = useState(cachedAuthStatus?.authenticated || false);
    const [user, setUser] = useState(cachedAuthStatus?.user || null);
    const [loading, setLoading] = useState(!cachedAuthStatus);

    useEffect(() => {
        let isMounted = true;

        const fetchUserStatus = async () => {
            try {
                const results = await getAuthStatus();
                if (isMounted) {
                    setAuthenticated(results.authenticated);
                    setUser(results.user);
                }
            } catch (error) {
                console.error('Error:', error);
            }
            if (isMounted) {
                setLoading(false);
            }
        };

        fetchUserStatus();

        return () => {
            isMounted = false;
        };
    }, []);

    return { authenticated, user, loading };
};

export default useAuthStatus;
